import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useAppLayoutContext, useAppLayoutWidth } from './useAppLayoutContext';

/**
 * Returns whether the leftnav is suppressed based on the current app layout width.
 *
 * When the collapsible nav is active, the nav stays visible (as a collapsed icon-only
 * rail) down to a narrower width before being suppressed.
 */
export const useIsLeftNavSuppressedAtCurrentWidth = (): boolean => {
  const isLeftNavCollapsible = useAppLayoutContext()?.isLeftNavCollapsible ?? false;
  const suppressionBreakpoint = isLeftNavCollapsible ? AppLayoutBreakpoint.Width632 : AppLayoutBreakpoint.Width812;

  return useAppLayoutWidth() < suppressionBreakpoint;
};
